import 'babel-polyfill'
import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import Vuex from 'vuex'
import store from './store'
import router from './router'
import VueLazyLoad from 'vue-lazyload'
import '@/assets/css/reset.styl'
import './components'
import './filters'

import EasySlider from 'vue-easy-slider'
Vue.use(EasySlider)

Vue.use(Vuex)

Vue.prototype.$http = axios;

Vue.config.productionTip = false

Vue.use(VueLazyLoad,{
  error:'./static/error.png',
  loading:'https://img.yzcdn.cn/vant/apple-2.jpg'
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
